namespace Areas.Dialogs.Jobs {
    "use strict";

    export class JobsDialog extends Areas.BaseDialog {
        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void, parameters: any = null) {
            super("Jobs", closeHandler)
        }

        protected ok = (e: any) => {
            const dataGrid = $(`#${this.dialogName}LookupGrid`).dxDataGrid('instance');
            const selectedRows: any = dataGrid.getSelectedRowsData();
    
            if (selectedRows[0] == null) {
                DevExpress.ui.notify("Please make a selection first!", "warning", 2000);
            } else {
                var data = selectedRows[0];
                this.close(DialogResult.Ok, data);
            }
        }
   }
   

}

